/** Shared reporting days use UTC, independently of the browser timezone. */
export const getReportingToday = (now = new Date()): string =>
  now.toISOString().slice(0, 10);

export const isReportingDate = (value: string): boolean => {
  if (!/^\d{4}-\d{2}-\d{2}$/.test(value) || value.startsWith('0000-'))
    return false;
  const date = new Date(`${value}T00:00:00.000Z`);
  return (
    Number.isFinite(date.getTime()) && date.toISOString().slice(0, 10) === value
  );
};

export const getHistoricalKpiDate = (
  calendarDate?: string,
  now = new Date()
): string | undefined => {
  if (!calendarDate) return undefined;
  if (isReportingDate(calendarDate)) {
    // Future modeled scenarios also start from the latest observed KPI values.
    return calendarDate < getReportingToday(now) ? calendarDate : undefined;
  }
  // Other dashboard callers supply explicit instants. Preserve their precision
  // and offset instead of reinterpreting them as a reporting calendar day.
  if (
    /^\d{4}-\d{2}-\d{2}T([01]\d|2[0-3]):[0-5]\d:[0-5]\d(?:\.\d{1,6})?(?:Z|[+-](?:0\d|1[0-5]):[0-5]\d)$/.test(
      calendarDate
    ) &&
    isReportingDate(calendarDate.slice(0, 10)) &&
    Number.isFinite(Date.parse(calendarDate))
  ) {
    return Date.parse(calendarDate) < now.getTime() ? calendarDate : undefined;
  }
  throw new Error('Invalid reporting date');
};

// Date-fns pickers use local Date fields as calendar fields. Never parse a bare
// YYYY-MM-DD as an instant here, or serialize picker values with toISOString().
export const reportingDateToPicker = (value: string): Date | null =>
  isReportingDate(value) ? new Date(`${value}T12:00:00`) : null;

export const reportingDateFromPicker = (date: Date): string =>
  `${String(date.getFullYear()).padStart(4, '0')}-${String(date.getMonth() + 1).padStart(2, '0')}-${String(date.getDate()).padStart(2, '0')}`;
